<template>
  <shop-audit-list title="加盟商审核"></shop-audit-list>
</template>

<script>
import ShopAuditList from "@view/components/shop/audit-list.vue";

export default {
  name: "",
  components: {ShopAuditList},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>

<style scoped>

</style>
